import { useEffect, useRef, useCallback, useState } from "react";
import priority_high_svg from "../../../common/icons/svg/priority-high.svg";
import priority_medium_svg from "../../../common/icons/svg/priority-medium.svg";
import priority_low_svg from "../../../common/icons/svg/priority-low.svg";
import { getAlarmHistory } from "../../../helper/alarm-helper";
import moment from "moment";
import { ALARM_TYPE_FILTER, ALARM_PRIORITY_FILTER, USER_VIEW } from "../../../common/constant/common-constants";
import MonitorAlarmTableDesktopView from "./MonitorAlarmTableDesktopView";
import MonitorAlarmTableMobileView from "./MonitorAlarmTableMobileView";

export function MonitorAlarmTable(props) {
    const [data, setData] = useState([]);
    const [activeAlarm, setActiveAlarm] = useState([]);
    const [endOffPage, setEndOffPage] = useState(false);
    const [createdAt, setCreatedAt] = useState(null);
    const [offset, setOffset] = useState(null);
    const tableRef = useRef(null);
    const isFetchingRef = useRef(false);
    const [isLoading, setIsLoading] = useState(false);


    const [filterDropdown, setFilterDropdown] = useState({ open: false, column: null });
    const [selectedTypeFilter, setSelectedTypeFilter] = useState(ALARM_TYPE_FILTER?.[0]?.name);
    const [selectedPriorityFilter, setPrioritySelectedFilter] = useState(ALARM_PRIORITY_FILTER?.[0]?.name);
    const dropdownRef = useRef(null);

    const resetState = () => {
        setEndOffPage(false);
        setData([]);
        setCreatedAt(null);
        setOffset(null);
    }

    const getPMAlarm = (created, offs, selectedTypeFilter, selectedPriorityFilter) => {
        if (endOffPage) return;
        setIsLoading(true)
        getAlarmHistory(
            {
                bedId: props.bedId,
                typefilter: selectedTypeFilter,
                priorityfilter: selectedPriorityFilter,
                createdAt: created ? created?.toString() : null,
                limit: 100,
                offset: offs ? offs : null,
            }
        ).then((res) => {
            if (res?.alarms?.length < 100) setEndOffPage(true);
            const PMAlarms = res.alarms;
            if (PMAlarms) {
                if (!created) setCreatedAt(PMAlarms?.[0]?.createdAt);
                setData((prevData) => {
                    setOffset(prevData.length + PMAlarms.length);
                    return [...prevData, ...PMAlarms]
                });
            }
        }).finally(() => {
            isFetchingRef.current = false;
            setIsLoading(false)
        })
            .catch((err) => {
                console.log("alarm err: ", err);
            });
    }

    const handleScroll = useCallback(() => {
        const table = tableRef.current;
        if (table) {
            const scrollPosition = table.scrollTop + table.clientHeight;
            const isLastRows = scrollPosition >= table.scrollHeight - table.clientHeight * 0.1;

            if (isLastRows && !isFetchingRef.current && offset) {
                isFetchingRef.current = true;
                getPMAlarm(createdAt, offset, selectedTypeFilter, selectedPriorityFilter);
            }
        }
    }, [offset]);



    useEffect(() => {
        const table = tableRef.current;
        if (table) {
            table.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (table) {
                table.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll]);


    useEffect(() => {
        if (!offset) getPMAlarm(null, null, selectedTypeFilter, selectedPriorityFilter);
    }, [offset])


    useEffect(() => {
        let activeAl = [];
        let activeAlarmsPM = [...props.PMAlarmData.PM_alarms.alarms_physiological, ...props.PMAlarmData.PM_alarms.alarms__technical]
        activeAlarmsPM?.forEach(e => {

            activeAl.push({
                category: null,
                createdAt: null,
                message: e.message,
                activeTime: moment(e.time).format("YYYY-MM-DD HH:mm:ss"),
                priority: e.priority,
                resolvedTime: null,
                subcategory: null,
                type: e.type,
                status: 'active'
            })
        });
        setActiveAlarm(activeAl);
    }, [props.PMAlarmData]);

    useEffect(() => {
        resetState();
    }, [props.bedId, selectedTypeFilter, selectedPriorityFilter]);

    const toggleFilterDropdown = (column) => {
        setFilterDropdown((prev) => ({
            open: !(prev.open && prev.column === column),
            column,
        }));
    };

    const handleFilterSelect = (filter, data) => {
        if (data === "TYPE") {
            setSelectedTypeFilter(filter.name);
            setPrioritySelectedFilter(ALARM_PRIORITY_FILTER?.[0]?.name)
        }
        if (data === "PRIORITY") {
            setPrioritySelectedFilter(filter.name)
        };

        if (data === "MOBILE-VIEW-FILTER") {
            setSelectedTypeFilter(filter.name);
            setPrioritySelectedFilter(ALARM_PRIORITY_FILTER?.[0]?.name)
        }
        setFilterDropdown({ open: false, column: null });
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setFilterDropdown({ open: false, column: null });
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const getPriority = (priority) => {
        let pr = priority?.toUpperCase();
        switch (pr) {
            case "HIGH":
                return { icon: priority_high_svg, color: '#AD0606', textColor: '#fff' };
            case "MEDIUM":
                return { icon: priority_medium_svg, color: '#FCC331', textColor: '#000' };
            case "LOW":
                return { icon: priority_low_svg, color: '#3ADAE5', textColor: '#000' };
            default:
                return { icon: '', color: '#3ADAE5' };
        }
    }

    let livealarms = [...activeAlarm].sort((a, b) => new Date(b.activeTime) - new Date(a.activeTime))
    let sortedEvents = [...livealarms, ...data] || [];

    let filteredEvents = (selectedTypeFilter === 'ACTIVE') ? [...livealarms] : sortedEvents.filter(event => selectedTypeFilter == ALARM_TYPE_FILTER?.[0]?.name || event.type === selectedTypeFilter);

    return (
        <>
            {props.userView === USER_VIEW.DESKTOP && (
                <MonitorAlarmTableDesktopView
                    monitorConnected={props.monitorConnected}
                    tableRef={tableRef}
                    header={props.header}
                    sortedEvents={filteredEvents}
                    selectedTypeFilter={selectedTypeFilter}
                    selectedPriorityFilter={selectedPriorityFilter}
                    toggleFilterDropdown={toggleFilterDropdown}
                    filterDropdown={filterDropdown}
                    dropdownRef={dropdownRef}
                    handleFilterSelect={handleFilterSelect}
                    getPriority={getPriority}
                    isLoading={isLoading}
                />
            )}

            {props.userView === USER_VIEW.MOBILE && (
                <MonitorAlarmTableMobileView
                    monitorConnected={props.monitorConnected}
                    tableRef={tableRef}
                    sortedEvents={filteredEvents}
                    getPriority={getPriority}
                    isLoading={isLoading}
                    selectedTypeFilter={selectedTypeFilter}
                    handleFilterSelect={handleFilterSelect}
                />
            )}
        </>
    );

}
